<template>
  <v-row>
    <v-col>
      <div class="d-flex flex-1 align-center mb-5">
        <img src="../../assets/icons/sorts/envelop.png" class="tcdc-send-message-icon mr-4" />
        <span class="text-tcdc-green sub-header1 bold text-uppercase">{{$t('enewsletter.sendus')}}</span>
      </div>
      <div v-if="mode === 'about'">
        <div class="mb-5" v-if="aboutContact[`description_${lang}`]">
          <div class="vhtml" v-html="aboutContact[`description_${lang}`]"></div>
        </div>
      </div>
      <div v-else>
        <div class="mb-5" v-if="venue_hire.contact_email && venue_hire.contact_info">
          <div class="vhtml" v-html="venue_hire.contact_email"></div>
          <div class="vhtml" v-html="venue_hire.contact_info"></div>
        </div>
      </div>
      <v-text-field :label="$t('enewsletter.email')+':'" v-model="form.email" type="email" outlined color="#2e8037"></v-text-field>
      <v-text-field :label="$t('enewsletter.tel')+':'" v-model="form.phone" outlined color="#2e8037"></v-text-field>
      <v-textarea
        outlined
        name="input-7-4"
        :label="$t('enewsletter.message')+':'"
        v-model="form.message"
        value
        color="#2e8037"
      ></v-textarea>
      <GreenButton :label="$t('enewsletter.send')" @onPress="onSubmit" />
    </v-col>
  </v-row>
</template>

<script>
import GreenButton from "../../components/buttons/GreenButton";
import { mapState } from 'vuex';
export default {
  props: ['mode'],
  components: {
    GreenButton
  },
  data: () => ({
    form: {
      email: "",
      phone: "",
      message: ""
    }
  }),
  created() {
    if (!this.aboutContact) {
      this.$store.dispatch("About/getAboutAllMenu", { branch_id: this.branchId, lang: this.lang });
    }
  },
  mounted() {
    this.loadReCAPTCHAScript();
  },
  beforeDestroy() {
    this.$forceUpdate()
    this.$nextTick(() => {
      const script = document.getElementById("recaptcha-script");
      const script_el = document.getElementsByClassName("grecaptcha-badge");

      if (script) {
        script.remove()
        script_el[0].remove()
      }
    })
  },
  computed: {
    ...mapState({
      branchId: state => state.Branch.branch_id,
      venue_hire: state => state.ServiceMenu.venture_hire,
      aboutContact: state => state.About.contact,
      lang: state => state.Branch.lang
    })
  },
  methods: {
    async onSubmit() {
      const siteKey = '6LdUeYIqAAAAAMb6B1F6t-vGkhzdX9mCSZdeC4c2';
      this.form.token = await grecaptcha.execute(siteKey, { action: "submit" });

      if (this.venue_hire && this.venue_hire.contact_email && this.mode != 'about') {
        this.form.to = this.venue_hire.contact_email;
      }
      this.$emit("onSubmit", this.form);
      await new Promise(x => setTimeout(x, 1000));
      this.form.email = "";
      this.form.phone = "";
      this.form.message = "";
      this.form.to = "";
      this.form.token = "";
    },
    loadReCAPTCHAScript() {
      if (!document.getElementById("recaptcha-script")) {
        const script = document.createElement("script");
        script.id = "recaptcha-script";
        script.src = "https://www.google.com/recaptcha/api.js?render=6LdUeYIqAAAAAMb6B1F6t-vGkhzdX9mCSZdeC4c2";
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tcdc-send-message-icon {
  height: 25px;
  object-fit: contain;
}
</style>

<style>
/* ย้าย badge reCAPTCHA ไปมุมซ้ายล่าง ไม่ให้ซ้อนกับปุ่มคุกกี้ */
.grecaptcha-badge {
  left: 4px !important;
  right: auto !important;
  width: 70px !important;
  overflow: hidden !important;
  transition: width 0.3s ease !important;
}
.grecaptcha-badge:hover {
  width: 256px !important;
}
</style>
